const KEY_PSEUDO = 'pseudo'

const applicationIdentityKey = process.env.APP_CODE
const applicationBiz = process.env.APP_BIZ

export default {
  namespaced: true,
  state () {
    return {
      authenticated: !!localStorage.getItem(KEY_PSEUDO),
      me: null
    }
  },
  getters: {
    isAuthenticated (state) {
      return state.authenticated
    },
    authorization (state) {
      return ''
    },
    isMeLoaded (state) {
      return state.authenticated && state.me && !!state.me.uuid
    },
    me (state) {
      return state.me
    },
    hasRole: (state, getters) => role => {
      if (!role) {
        return true
      }
      return getters.isMeLoaded && state.me.roles.includes(role)
    }
  },
  mutations: {
    setMe (state, me) {
      let applicationInfo = me.applications.find(application => {
        return application.application === applicationIdentityKey
      })
      state.me = Object.assign({}, me, applicationInfo)
    },
    shake (state) {
      state.authenticated = !!localStorage.getItem(KEY_PSEUDO)
      if (!state.authenticated) {
        state.me = null
      }
    },
    saveMe (state, me) {
      localStorage.setItem(KEY_PSEUDO, JSON.stringify(me))
    },
    clearAuth (state) {
      state.authenticated = false
      state.me = null
      localStorage.removeItem(KEY_PSEUDO)
    }
  },
  actions: {
    authorize ({ commit }) {
      //
    },
    signIn ({ commit }, me) {
      return new Promise((resolve, reject) => {
        me[applicationIdentityKey] = {
          app: applicationIdentityKey,
          biz: applicationBiz,
          roles: ['basic']
        }
        commit('saveMe', me)
        commit('setMe', me)
        commit('shake')
        return resolve()
      })
    },
    signOut ({ commit }) {
      commit('clearAuth')
    },
    refresh ({ commit, state }) {
      commit('shake')
      let renewToken = function () {
        return new Promise((resolve, reject) => {
          return resolve()
        })
      }
      let reload = function () {
        return new Promise((resolve, reject) => {
          if (state.authenticated && state.me === null) {
            commit('setMe', JSON.parse(localStorage.getItem(KEY_PSEUDO)))
            return resolve()
          }
          return resolve()
        })
      }
      return renewToken().then(function () {
        return reload()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/store/pseudo.js